import { mapGetters, mapActions } from 'vuex'
import { eventBus } from '@/main'

export default {
    computed: {
        ...mapGetters({
            coursesReceived: 'courses/Courses',
        }),
    },
    methods: {
        ...mapActions({
            FetchCoursesByCourseCodes: 'courses/FetchCoursesByCourseCodes',
        }),
        LoadCoursesByCourseCodes(courseCodes) {
            eventBus.$emit('courses-fetch:started');
            this.FetchCoursesByCourseCodes({ CourseCodes: courseCodes })
                .then(() => {
                    this.courses = [...this.coursesReceived];
                    eventBus.$emit('courses-fetch:success');
                })
                .catch(error => eventBus.$emit('console:error', error))
                .finally(() => eventBus.$emit('courses-fetch:finished'));
        },
    },
};